export const ACTIONS = {
    AUTHENTICATION: 'AUTHENTICATION',
    ACTIVATION: 'ACTIVATION',
    REGISTRATION: 'REGISTRATION',
    PASSWORD_RECOVERY: 'PASSWORD_RECOVERY',
    APPSUMO_COMPLETE_REGISTRATION: 'APPSUMO_COMPLETE_REGISTRATION',
}
